import { Pagination } from '@mui/material';
import { gridPageCountSelector, gridPageSelector, useGridApiContext, useGridSelector } from '@mui/x-data-grid';


type Props = {}

const UcDgvCustomPagination = (props: Props) => {
  const apiCtx = useGridApiContext();

  const page = useGridSelector(apiCtx, gridPageSelector);// 當前頁數 (0=第一頁)
  const pageCount = useGridSelector(apiCtx, gridPageCountSelector);

  return (
    <div>
      <Pagination
        color="primary"
        count={pageCount}
        page={page + 1}
        onChange={(event, value) => apiCtx.current.setPage(value - 1)}
      />
    </div>
  );
}

export default UcDgvCustomPagination

